var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"block",staticClass:"open-block-but-better"},[_vm._t("default",null,{"toggle":_vm.toggle,"isOpen":_vm.isOpen})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }